import { requestAuth } from "common-frontend-components";
import axios from 'axios';
import { appConfig } from "../variables/appConfig";
export function callGetProductPhotoByKeyAsync(key) {
    return axios.post(`${appConfig.productPhotosUrl}/get-by-key`, { key })
        .then((response) => {
        if (response.data === null)
            return null;
        response.data.created = new Date(response.data.created);
        return response.data;
    });
}
export function callGetProductPhotosByProductIdAsync(productId) {
    return axios.get(`${appConfig.productPhotosUrl}/productId/${productId}`)
        .then((response) => {
        if (response.data === null)
            return null;
        response.data.forEach(i => { i.created = new Date(i.created); });
        return response.data;
    });
}
export function callGetProductPhotosAsync() {
    return axios.get(`${appConfig.productPhotosUrl}`)
        .then((response) => {
        response.data.forEach(photo => {
            photo.created = new Date(photo.created);
        });
        return response.data;
    });
}
export async function callUploadProductPhotoAsync(photoFile, metadata) {
    const initiateResult = await requestAuth.post(`${appConfig.productPhotosUrl}/initiate-upload`, metadata);
    await axios.put(initiateResult.s3PutObjectUrl, photoFile, {
        headers: {
            'Content-Type': metadata.contentType,
        },
    });
    return initiateResult;
}
export const callProductPhotoDeletionByKeyAsync = (key) => requestAuth.post(`${appConfig.productPhotosUrl}/delete-by-key`, { key });
//# sourceMappingURL=productPhotos.js.map